<template>
  <ul class="step-dots">
    <li
      v-for="n in total"
      :key="n"
      :class="['step-dots__dot', { 'step-dots__dot--active': step === n - 1 }]"
      @click="$emit('change', n - 1)"
    />
  </ul>
</template>

<script lang="ts">
import { defineComponent } from 'vue';

export default defineComponent({
  emits: { change: null },
  props: {
    total: {
      type: Number,
      required: true,
    },

    step: {
      type: Number,
      required: true,
    },
  },
});
</script>

<style lang="scss">
@use 'settings/colors';

.step-dots {
  list-style-type: none;
  display: grid;
  grid-gap: 4px;
  grid-auto-flow: column;
  margin: 0;
  padding: 0;
}

.step-dots__dot {
  height: 8px;
  width: 8px;
  border-radius: 50%;
  background: colors.$color-grey-300;
  transition: all 0.1s ease-in-out;
  cursor: pointer;
}

.step-dots__dot--active {
  background: colors.$color-blue;
}
</style>
